import React from 'react';
import { ChevronLeft, ChevronRight, Settings, BoxIcon } from 'lucide-react';
interface Tab {
  icon: BoxIcon;
  label: string;
  active: boolean;
}
interface TabNavigationProps {
  tabs: Tab[];
}
export function TabNavigation({
  tabs
}: TabNavigationProps) {
  return <div className="border-b border-gray-200 px-4 flex items-center justify-between" data-id="element-2252">
      <div className="flex items-center" data-id="element-2253">
        <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-2254">
          <ChevronLeft size={20} data-id="element-2255" />
        </button>
        <div className="flex overflow-x-auto hide-scrollbar" data-id="element-2256">
          {tabs.map((tab, index) => {
          const Icon = tab.icon;
          return <button key={index} className={`flex items-center px-4 py-3 whitespace-nowrap ${tab.active ? 'text-orange-500 border-b-2 border-orange-500' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-2257">
                <Icon size={18} className="mr-2" data-id="element-2258" />
                <span data-id="element-2259">{tab.label}</span>
              </button>;
        })}
        </div>
        <button className="p-2 text-gray-400 hover:text-gray-600" data-id="element-2260">
          <ChevronRight size={20} data-id="element-2261" />
        </button>
      </div>
      <button className="p-2 text-gray-500 hover:text-gray-700" data-id="element-2262">
        <Settings size={20} data-id="element-2263" />
      </button>
    </div>;
}